<template>
    <div class="dot-third" :class="dotClass" />
</template>
<script>
export default {
    props: {
        type: {
            type: String,
            required: true,
            validator(value) {
                return [
                    'contact',
                    'client',
                    'prospect',
                    'supplier',
                    'company',
                    'individual',
                    'archived',
                    'reference',
                    'custom',
                ].includes(value);
            },
        },
    },
    computed: {
        dotClass() {
            return `dot-third--${this.type}`;
        },
    },
};
</script>
<style lang="scss" scoped>
.dot-third {
    border: 1px solid transparent;
    border-radius: 50%;
    display: inline-block;
    height: 9px;
    width: 9px;

    &--company {
        background-color: var(--colors-component-background-information-tag-subtle-brand);
        border-color: var(--colors-component-border-tag-blue);
    }

    &--client {
        background-color: var(--colors-component-background-information-tag-subtle-light-blue);
        border-color: var(--colors-component-border-tag-light-blue);
    }

    &--prospect {
        background-color: var(--colors-component-background-information-tag-subtle-purple);
        border-color: var(--colors-component-border-tag-purple);
    }

    &--supplier {
        background-color: var(--colors-component-background-information-tag-subtle-coral);
        border-color: var(--colors-component-border-tag-coral);
    }

    &--individual {
        background-color: var(--colors-component-background-information-tag-subtle-orange);
        border-color: var(--colors-component-border-tag-orange);
    }
}
</style>
